import React, { Component } from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { Link } from 'src/components/LinkButton'
import Button from 'src/components/Button'
import SvgIcon from 'src/components/SvgIcon'
import intlMessagesApp from 'src/modules/App/translations'
import styles from './FieldPreview.module.less'

class FieldPreview extends Component {
  state = {
    isEdited: false,
  }
  componentDidMount() {
    document.addEventListener('keydown', this.onKeyDown, false)
  }
  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown, false)
  }

  onKeyDown = event => {
    // If ESC key is clicked
    if (event.keyCode === 27) {
      this.setIsEdited(false)
    }
  }

  setIsEdited = isEdited => {
    this.setState({
      isEdited: isEdited,
    })
  }

  getStateAndHelpers() {
    return {
      fieldPreviewSetIsEdited: this.setIsEdited,
    }
  }

  render() {
    const {
      children,
      intl,
      fieldName,
      fieldError,
      className,
      plainFieldClassName,
      label,
      displayValue,
      isFirst,
      isPlainField,
    } = this.props
    const { isEdited } = this.state

    const classNames = cx({
      [styles.fieldPreview]: true,
      [styles.isNotFirst]: isFirst !== true,
      [className]: !!className,
    })
    const plainFieldClassNames = cx({
      [plainFieldClassName]: !!plainFieldClassName,
    })

    if (isPlainField) {
      return (
        <div className={plainFieldClassNames} key={`form-field-plain-preview_${fieldName}`}>
          {children(this.getStateAndHelpers())}
        </div>
      )
    }

    return (
      <div className={classNames} key={`form-field-preview_${fieldName}`}>
        <div className={styles.valuePreview}>
          <div className={styles.valueHolder}>
            <div className={styles.label}>{label}</div>
            <div className={styles.value}>{displayValue()}</div>
            {fieldError ? <div className={styles.fieldError}>{fieldError}</div> : ''}
          </div>

          <div>
            <Link className={styles.changeLink} onClick={() => this.setIsEdited(true)}>
              {intl.formatMessage(intlMessagesApp.appGlobalChange)}
            </Link>
          </div>
        </div>

        <div className={!isEdited ? styles.floatyFieldHidden : ''}>
          <div className={styles.floatyFieldMaskOverlay} onClick={() => this.setIsEdited(false)} />
          <div className={styles.floatyFieldHolder}>
            <div className={styles.floatyFieldHolderInner}>
              <SvgIcon
                type='RemoveIcon'
                className={styles.floatyFieldHolderClose}
                onClick={() => this.setIsEdited(false)}
              />
              <div className={styles.floatyFieldLabel}>{label}</div>
              <div>{children(this.getStateAndHelpers())}</div>
              <Button onClick={() => this.setIsEdited(false)} className={styles.floatyFieldButton}>
                {intl.formatMessage(intlMessagesApp.appGlobalClose)}
              </Button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

FieldPreview.propTypes = {
  intl: PropTypes.object.isRequired,
  fieldName: PropTypes.string.isRequired,
  className: PropTypes.string,
  plainFieldClassName: PropTypes.string,
  label: PropTypes.string,
  displayValue: PropTypes.func,
  isFirst: PropTypes.bool,
  isPlainField: PropTypes.bool,
}

FieldPreview.defaultProps = {
  className: null,
  plainFieldClassName: null,
  label: null,
  isFirst: false,
  isPlainField: false,
}

export default injectIntl(FieldPreview)
